/* eslint-disable object-property-newline */
/* eslint-disable no-lonely-if */
import gsap from 'gsap';
import Utils from '../utils';

const audioManagerComponent = {

  init() {
    window.audioManager = this;
    this.aScene = document.querySelector('a-scene');
    this.getComponents();
    this.subscribeToEvents();
  },

  getComponents() {
    this.backgroundSound = this.aScene.querySelector('#backgroundSound'); 
  },

  subscribeToEvents() {
    window.addEventListener('blur', () => {
      if (this.backgroundSound) {
        this.setMuted(true);
      }
    });
    window.addEventListener('focus', () => {
      if (this.backgroundSound) {
        this.setMuted(false);
      }
    });
  },

  setMuted(newStatus = true) {
    if (this.aScene && this.aScene.audioListener) {
      this.aScene.audioListener.setMasterVolume(newStatus ? 0 : 1);
    }
  },

  playSoundElement(soundElementSelector = '') {
    const soundElement = this.aScene.querySelector(soundElementSelector);
    if (soundElement) {
      soundElement.components.sound.playSound();
    }
    else {
      console.warn("playSoundElement() Couldn't find element with selector:", soundElementSelector);
    }
    // TODO: window.audioManager.playSoundElement('#buttonSound'); cuando se usan los botones. ¿También cuando se confirma el fuse?
  },

  stopSoundElement(soundElementSelector = '') {
    const soundElement = this.aScene.querySelector(soundElementSelector);
    if (soundElement) {
      soundElement.components.sound.stopSound();
    }
    else {
      console.warn("stopSoundElement() Couldn't find element with selector:", soundElementSelector);
    }
  },

  playBackgroundSound() {
    if (Utils.paramIsEnabled('musicDisabled')) return;
    if (this.backgroundSound) {
      this.backgroundSound.components.sound.playSound();
    }
  },
};

export default audioManagerComponent;
